import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

/**
 * Aplicar em um elemento overlay ancorado acima do rodapé (position: absolute;
 * bottom: 100%) que cobre a parte de baixo do ion-content — ex.: o resumo de
 * itens selecionados das telas de complementos/pizza.
 *
 * Mantém o --padding-bottom do ion-content da página igual à altura do
 * overlay, para o fim da lista nunca ficar escondido embaixo dele. O overlay
 * fica FORA do fluxo justamente para o container de scroll nunca mudar de
 * tamanho: redimensionar o container dispara o re-clamp do scroll por toque
 * no iOS/WebKit (pulos e itens inalcançáveis). Crescer só o padding altera
 * apenas o scrollHeight, o que todos os engines tratam corretamente.
 */
@Directive({ selector: '[appOverlayScrollPadding]' })
export class OverlayScrollPaddingDirective implements AfterViewInit, OnDestroy {
	private resizeObserver: any;

	constructor(private elRef: ElementRef<HTMLElement>) {}

	ngAfterViewInit() {
		const ResizeObserverCtor = (window as any).ResizeObserver;
		if (!ResizeObserverCtor) return;

		const overlay = this.elRef.nativeElement;
		// primeiro ancestral que contém um ion-content = a própria página
		// (não usar closest('.ion-page'): o router só adiciona a classe depois)
		let scope = overlay.parentElement;
		while (scope && !scope.querySelector('ion-content')) scope = scope.parentElement;
		const content = scope && (scope.querySelector('ion-content') as HTMLElement);
		if (!content) return;

		this.resizeObserver = new ResizeObserverCtor(() => {
			content.style.setProperty('--padding-bottom', overlay.offsetHeight + 'px');
		});
		this.resizeObserver.observe(overlay);
	}

	ngOnDestroy() {
		if (this.resizeObserver) this.resizeObserver.disconnect();
	}
}
